import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { api } from '../api'
import { ClientPortalInvite } from '../types'

export const useSendClientPortalInvite: WriteHook<ClientPortalInvite, number> = (opts) =>
  useMutationManager<ClientPortalInvite, number>(api.sendClientPortalInvite, opts)
